// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"585":"5ad0f9d0","952":"5fc91446"}[chunkId] + ".chunk.js");